import React, { useState } from 'react';
import { IconButton, Menu } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';

interface MoreOptionsMenuProps {
  disabled?: boolean;
}

const MoreOptionsMenu: React.FC<MoreOptionsMenuProps> = (props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  return (
    <React.Fragment>
      <IconButton
        disabled={props.disabled || !React.Children.toArray(props.children)?.length}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        <MoreVert />
      </IconButton>
      {!props.disabled && (
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          open={open}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          onClick={() => setAnchorEl(null)}
          onClose={() => setAnchorEl(null)}
        >
          {props.children}
        </Menu>
      )}
    </React.Fragment>
  );
};

export default MoreOptionsMenu;
